import React from "react";
import Form from "../components/AddNewJob/Form";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";

export default function AddNewJob() {
  return (
    <>
      <Navbar />

      <div className="max-w-[90rem] mx-auto px-4 sm:px-6 md:px-8">
        <Sidebar />

        <div className="lg:pl-[14rem] mt-[5.8125rem]">
          <main className="max-w-3xl rounded-lg mx-auto relative z-20 p-10 xl:max-w-none bg-[#1E293B]">
            <h1 className="mb-10 text-center section-title">Add New Job</h1>

            <div className="max-w-3xl mx-auto">
              <Form />
            </div>
          </main>
        </div>
      </div>
    </>
  );
}
